export const popupContainerStyle = {
  left: "-120px",
  zIndex: 1500,
};
